module.exports = __webpack_public_path__ + "static/logo_en.5b1ec848.svg";


//////////////////
// WEBPACK FOOTER
// ./src/layouts/assets/logo_en.svg
// module id = 603
// module chunks = 114276838955818